import * as config from '@/shared/config/config';
import Vue from 'vue';

export const store = config.initVueXStore(Vue);
